import { QueryQrCodeArgs } from '../generated';
import { prepareDataForApolloCache } from '../prepareDataForApolloCache';
import { trelloFetch } from '@trello/fetch';
import type { TrelloRestResolver } from '../types';
import { getNetworkClient } from '../getNetworkClient';
import { isQueryInfo } from '../isQueryInfo';

export const qrCodeResolver: TrelloRestResolver<QueryQrCodeArgs> = async (
  _parent,
  args,
  context,
  info,
) => {
  const rootNode = isQueryInfo(info) ? info.field : info.fieldNodes[0];
  const networkClient = getNetworkClient();
  const apiUrl = networkClient.getUrl('/1/share/qrcode');
  const url = encodeURIComponent(args.url);
  const response = await trelloFetch(
    `${apiUrl}?url=${url}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {
      clientVersion: context.clientAwareness.version,
      networkRequestEventAttributes: {
        source: 'graphql',
        resolver: 'Board_History.cardsPerList',
        operationName: context.operationName,
      },
    },
  );
  const qrCode = await response.json();

  return prepareDataForApolloCache(
    { imageData: qrCode._value || '' },
    rootNode,
  );
};
